import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { GestureController, Platform, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss'],
})
export class TimerComponent implements OnInit {
  @ViewChild('time') time: ElementRef;
  @Input() currentTime: any;

  constructor(
    // public gestureCtrl: GestureController,
    public platform: Platform,
    public popOverController: PopoverController
  ) {}

  ngOnInit() {
    this.start();
  }

  async start() {
    await this.platform.ready();
    // const gesture = this.gestureCtrl.create(
    //   {
    //     gestureName: '',
    //     el: this.time.nativeElement,
    //     threshold: 1,
    //     direction: 'x',
    //     onMove: (data) => {
    //       if (data.velocityX > 0) {
    //         this.addSecond();
    //       } else {
    //         this.subSecond();
    //       }
    //     },
    //   },
    //   true
    // );

    // gesture.enable();
  }

  subSecond() {
    console.log('subSecond');
    if (this.currentTime.second > 0) {
      this.currentTime.second--;
      if (this.currentTime.second == 0) {
        this.currentTime.second = 59;
        if (this.currentTime.minute > 0) {
          this.currentTime.minute--;
        }
      }
    }
  }
  addSecond() {
    console.log('addSecond');

    this.currentTime.second++;
    if (this.currentTime.second == 60) {
      this.currentTime.second = 0;
      this.currentTime.minute++;
    }
  }

  subMinute() {
    console.log('subMinute');
    if (this.currentTime.minute > -1) {
      this.currentTime.minute--;
      if (this.currentTime.minute < 0) {
        this.currentTime.minute = 12;
        // if (this.currentTime.second > 0) {
        //   this.currentTime.minute--;
        // }
      }
    }
  }
  addMinute() {
    console.log('addMinute');

    this.currentTime.minute++;
    // if (this.currentTime.minute == 12) {
    //   this.currentTime.second = 0;
    //   this.currentTime.minute++;
    // }
  }

  close() {
    this.popOverController.dismiss();
  }
  // async  closeTimer() {
  //   if (this.timerPopOver) {
  //     this.timerPopOver.dismiss().then(() => {
  //       this.timerPopOver = null;
  //     });
  //   }
  // }
}
